import { Box, ThemeUIStyleObject } from 'theme-ui';
import React from 'react';

import { stylePropsGridChild } from './style';

interface ColSpan {
  columns?: number | (number | null)[];
  start?: number | (number | null)[];
}

export interface GridChildProps {
  align?: 'end' | 'center' | 'start' | 'stretch';
  alignSelf?: string;
  children: React.ReactNode;
  className?: string;
  columnSpan?: number | string | ColSpan;
  padding?: string | number;
  rowSpan?: number | string;
  rowStart?: string;
  sx?: ThemeUIStyleObject;
}

const defaultProps = {
  align: 'stretch',
  className: ''
};

const GridChild = ({
  align,
  alignSelf,
  className,
  children,
  columnSpan,
  padding,
  rowStart,
  rowSpan,
  sx,
  ...props
}: GridChildProps): JSX.Element => (
  <Box
    {...props}
    sx={{
      ...stylePropsGridChild({
        align,
        alignSelf,
        padding,
        rowStart,
        rowSpan,
        columnSpan
      }),
      ...sx
    }}
    className={`GridChild ${className}`.trim()}
  >
    {children}
  </Box>
);

GridChild.defaultProps = defaultProps;

export default GridChild;
